export default __webpack_public_path__ + "static/media/icon-calendar.3a84bc27.svg";